const COMMON = {
  // used for PhoneInput o show flag
  DEFAULT_ISO_CODE: 'us',
}

export default COMMON
